import { PureComponent, createRef } from 'react'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader'
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry'
import ajaxTextureLoader from './ajaxTextureLoader'
import TextureAnimator  from './TextureAnimator'

import Enter from './enter-sed'
import ProgressData from './progress'
import DetailModal from './modal'

import { getContent } from '@/common/scene_content.js'

export default class Scene extends PureComponent {
  canvasRef = createRef()
  camera = null
  scene = null
  renderer = null
  controls = null
  transformControls = null
  font = null
  pickHandlers = []
  hoverHandlers = []
  interstPoints = []
  toPoints = []
  progressData = new ProgressData({ mockPercent: 85 })
  movingCameraAble = false
  movingCameraX = 0
  movingCameraY = 0
  movingCameraZ = 0
  destCameraAble = false
  destCameraX = 0
  destCameraY = 0
  destCameraZ = 0
  annieAction = ''
  annies = [] // animators-1
  boomer = null // animators-2

  //测试用
  axes = null
  testListener = null

  state = {
    progress: 0,
    modalVisible: false,
    modalType: "modal_s8_w1_imglist",
    // modalType: "modal_s13_w1_img",
    showEnter: true,
    videoBackground: false
  }

  changeVedioBackground = (status) => {
    this.setState({
      videoBackground: status
    })
  }

  openModal(modalType) {
    // mouseLight product21-trans logo-trans up-down-light num-light face
    // swiper orbitalVideo secondVideo inceptionVideo meadowfoamVideo uniqueVideo behindVideo historyVideo
    this.setState({
      modalVisible: true,
      modalType: modalType
    })
  }

  initScene () {
    this.renderer = new THREE.WebGLRenderer({
      logarithmicDepthBuffer: true,
      canvas: this.canvasRef.current
    });
    this.renderer.setPixelRatio(window.devicePixelRatio);
    this.renderer.setSize(window.innerWidth, window.innerHeight);

    this.scene = new THREE.Scene();

    this.camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.3, 1100);
    this.camera.position.set(0, 0, 0.01)


    //测试辅助线
    // this.axes = new THREE.AxisHelper(500);
    // this.scene.add(this.axes);
  }

  initControls () {
    const controls = new OrbitControls(this.camera, this.renderer.domElement);
    controls.enableZoom = false;
    controls.enablePan = false;
    controls.enableDamping = true;
    controls.rotateSpeed = 0.25;

    this.controls = controls
  }

  _selectObject (e) {
    e.preventDefault()

    const raycaster = new THREE.Raycaster();
    const mouse = new THREE.Vector2();

    //将鼠标点击位置的屏幕坐标转换成threejs中的标准坐标
    mouse.x = (e.clientX / this.renderer.domElement.clientWidth) * 2 - 1;
    mouse.y = - (e.clientY / this.renderer.domElement.clientHeight) * 2 + 1;

    // 通过鼠标点的位置和当前相机的矩阵计算出raycaster
    raycaster.setFromCamera(mouse, this.camera);

    // 获取raycaster直线和所有模型相交的数组集合
    return raycaster.intersectObjects(this.scene.children).filter(item => item.object.type !== 'AxesHelper');
  }

  init (cb) {
    const clock = new THREE.Clock()
    const animate = () => {
      requestAnimationFrame(animate);

      //摄像机工具
      // console.log("this.camera.position",  this.camera.position)
      const delta = clock.getDelta()

      this.annies.forEach((item) => {
        //动图效果start
        item.update(1000 * delta);
      })



      // if ( keyboard.pressed("z") )
      // {
      //   // do something
      // }

      // stats.update();
      //动图效果end

      this.controls.update(delta);
      this.renderer.render(this.scene, this.camera);
    }
    const loader = new FontLoader();

    loader.load(`${process.env.PUBLIC_URL}/fonts/gentilis_regular.typeface.json`, font => {
      this.font = font
      cb()
      animate()
      // 初始化点击事件
      window.addEventListener('click', (e) => {
        if (e.target !== this.canvasRef.current) return
        const selects = this._selectObject(e)

        if (selects.length > 0) {
          this.pickHandlers.forEach(handler => {
            handler(selects)
          })
        }
      }, false);

      // 初始化悬停事件
      let hoveredObject = null
      document.addEventListener('mousemove', (e) => {
        if (e.target !== this.canvasRef.current) return
        const selects = this._selectObject(e)

        if (selects.length > 0 && hoveredObject !== selects[0].object) {
          hoveredObject = selects[0].object
          this.hoverHandlers.forEach(handler => {
            handler(hoveredObject)
          })
        }
      }, false);

      window.addEventListener('resize', () => {
        this.camera.aspect = window.innerWidth / window.innerHeight;
        this.camera.updateProjectionMatrix();

        this.renderer.setSize(window.innerWidth, window.innerHeight);
      }, false);
    });
  }

  createLabel (name, location) {
    const textGeo = new TextGeometry(name, {
      font: this.font,
      size: 0.05,
      height: 0,
      curveSegments: 50,
      bevelSegments: 20
    });

    const textMaterial = new THREE.MeshBasicMaterial({ color: 0x000000 });
    const text = new THREE.Mesh(textGeo, textMaterial);

    text.position.copy(location);

    return text
  }

  // 开始迁移场景
  moving (action, oldFov) {
    if(this.movingCameraAble){
      this.cameraTraning(this.movingCameraX, this.movingCameraY+0.5, this.movingCameraZ,
        action, oldFov, 25)
      this.movingCameraAble = false
    }
  }

  // 移动摄像机指向目标点
  cameraTraning(x, y, z, action, oldFov, nowTime, offsetX, offsetY, offsetZ){
    if(nowTime > 1){
      if(!offsetX){
        offsetX = Math.abs(this.controls.target.x - x) / nowTime
      }
      if(!offsetY){
        offsetY = Math.abs(this.controls.target.y - y) / nowTime
      }
      if(!offsetZ){
        offsetZ = Math.abs(this.controls.target.z - z) / nowTime
      }
      if(this.controls.target.x > x){
        this.controls.target.x -= offsetX
      }else{
        this.controls.target.x += offsetX
      }
      if(this.controls.target.y > y){
        this.controls.target.y -= offsetY
      }else{
        this.controls.target.y += offsetY
      }
      if(this.controls.target.z > z){
        this.controls.target.z -= offsetZ
      }else{
        this.controls.target.z += offsetZ
      }
      nowTime --;
      requestAnimationFrame(() => {
        this.cameraTraning(x, y, z, action, oldFov, nowTime, offsetX, offsetY, offsetZ)
      });
    }else if(nowTime === 1){
      this.controls.target.x = x
      this.controls.target.y = y
      this.controls.target.z = z
      nowTime --;
      requestAnimationFrame(() => {
        this.cameraTraning(x, y, z, action, oldFov, nowTime, offsetX, offsetY, offsetZ)
      });
    }else{
      this.cameraFovMoving(action, oldFov)
    }
  }

  // 移动摄像机远近
  cameraFovMoving (action, oldFov){
    const camera = this.camera
    if (camera.fov > 48) {
      this.backgroundVitual();
      if (!oldFov) {
        oldFov = camera.fov
      }
      camera.fov = camera.fov - 1
      camera.updateProjectionMatrix();
      requestAnimationFrame(() => {
        this.cameraFovMoving(action, oldFov)
      });
    } else {
      action();
      camera.fov = oldFov
      this.controls.target.x = 0;
      this.controls.target.y = 0;
      this.controls.target.z = 0;
      this.controls.update();
      if(this.destCameraAble){
        camera.lookAt(this.destCameraX, this.destCameraY, this.destCameraZ)
        this.destCameraAble = false
      }
      camera.updateProjectionMatrix();
      this.backgroundNormal();
    }
  }

  sceneMesh = null
  // 场景虚化
  backgroundVitual () {
    this.sceneMesh.material.color.set('#808080')
  }
  // 场景正常化
  backgroundNormal () {
    this.sceneMesh.material.color.set('#ffffff')
  }


  //创建场景0
  init_scene_0 = () => {
    let sceneNum = 0
    const { language } = this.props;
    this.pickHandlers = []
    this.hoverHandlers = []
    this.scene = new THREE.Scene()

    const textureLoader = new ajaxTextureLoader()
    const geometry = new THREE.SphereBufferGeometry(500, 60, 40);
    geometry.scale(-1, 1, 1);

    textureLoader.load(getContent(language, 'scene_img_0'), texture => {
      // 纹理加载成功
      this.progressData.update(true, data => {
        this.setState({ progress: data })
      })
      const material = new THREE.MeshBasicMaterial({
        map: texture
      });

      var sceneMesh = new THREE.Mesh(geometry, material);
      sceneMesh.rotateY(-Math.PI / 2); //旋转网格模型
      this.sceneMesh = sceneMesh
      this.scene.add(sceneMesh);
      // 添加兴趣点
      this.createRunnerInterest(getContent(language, 'click_img_run'),-0.025, -0.325425+0.5, -1.25, "face", 0)
      this.createStaticInterest(getContent(language, 'click_img_shop'),-0.025+0.5, -0.325425+0.5, -1.25, "imgList", 0)
      this.createStaticInterest(getContent(language, 'click_img_video'),-0.025-0.5, -0.325425+0.5, -1.25, "video", 0)
      this.createStaticInterest(getContent(language, 'click_img_shop'),-0.025+1, -0.325425+0.5, -1.25, "img", 0)
      // 添加场景跳转点(测试用)
      // for(let i=0;i<=14;i++){
      //   if(i === sceneNum) continue
      //   if(i%2 === 0){
      //     this.createSceneCircle(getContent(language, 'move_img_common'),
      //       -0.025+i*0.1, -0.325425, -1.25, "scene_"+sceneNum, "to_scene_"+i, sceneNum+'_to_'+i, 0, 0, -1.525)
      //   }else{
      //     this.createSceneCircle(getContent(language, 'move_img_common'),
      //       -0.025-i*0.1, -0.325425, -1.25, "scene_"+sceneNum, "to_scene_"+i, sceneNum+'_to_'+i, 0, 0, -1.525)
      //   }
      // }
      // this.createSceneCircle(getContent(language, 'move_img_common'),
      //   -0.025, -0.325425, -1.25, "scene_0", "to_scene_1", '0_to_1', 0, 0, -1.525)
        //添加兴趣点事件
      this.add_interst_action()
        // 添加跳转事件
      this.add_toPoint_click_handle()
      // 测试场景
      this.create_scene(0)
      // this.axes.position.x  = -0.05
      // this.axes.position.y  = -0.65
      // this.axes.position.z  = -2
    }, xhr => {
      // 这里只是表示图片下载成功，onLoad 回调才表示成功加载为纹理
      this.progressData.update(xhr.loaded / xhr.total, data => {
        this.setState({ progress: data })
      })
    })
  }

  //创建场景0-14
  create_scene = (sceneNum) => {
    const { language } = this.props;
    this.pickHandlers = []
    this.hoverHandlers = []
    this.beforeDestroy()
    this.scene = new THREE.Scene()


    const geometry = new THREE.SphereBufferGeometry(500, 60, 40);
    geometry.scale(-1, 1, 1);

    var material = new THREE.MeshBasicMaterial({
      map: new THREE.TextureLoader().load(getContent(language, 'scene_img_'+sceneNum))
    });
    var sceneMesh = new THREE.Mesh(geometry, material);
    sceneMesh.rotateY(-Math.PI / 2); //旋转网格模型
    this.sceneMesh = sceneMesh
    this.scene.add(sceneMesh);
    this.camera.position.set(0,0,0.1)

    // 添加兴趣点
    // 添加场景跳转点(测试用)
    // const i = sceneNum+1
    // this.createSceneCircle(getContent(language, 'move_img_common'),
    //   -0.025, -0.325425, -1.25, "scene_"+sceneNum, "to_scene_"+i, sceneNum+'_to_'+i, 0, 0, -1.525)
    if(sceneNum === 0){
      this.createSceneCircle(getContent(language, 'move_img_common'),
          0,-0.325425,-1.25, "scene_0", "to_scene_1", +'0_to_1', 0, 0, -1.525)
    } else if(sceneNum === 1){
      this.createStaticInterest(getContent(language, 'click_img_video'),
          0.35,0.17457499999999998,-1.25, "modal_s1_w1_video", 0)
      // 向右
      this.createSceneCircle(getContent(language, 'move_img_common'),
          0.35 , -0.6254250000000001 , -1.25, "scene_1", "to_scene_2", +'', 0 , 0 , -3.270329251994328)
      // 向左
      this.createSceneCircle(getContent(language, 'move_img_common'),
          -0.35 , -0.6254250000000001 , -1.25, "scene_1", "to_scene_12", +'', 0 , 0 , 0)
      // 向下
      this.createSceneCircle(getContent(language, 'move_img_common'),
          0 , -0.7754250000000003 , -1.25, "scene_1", "to_scene_0", +'', 0 , 0 , 1.6165926535897934)
      // this.camera.position.set()
    }else if(sceneNum === 2){
      this.createRunnerInterest(getContent(language, 'click_img_run'),0.37499999999999994,0.32457499999999995,-1.25, "modal_s2_w1_imglist", 0)
      // 向右（回退）
      this.createSceneCircle(getContent(language, 'move_img_common'),
          0.35 , -0.7254250000000002 , -1.25, "scene_2", "to_scene_1", +'', 0 , 0 , -3.270329251994328)
      // 向左（前进）
      this.createSceneCircle(getContent(language, 'move_img_common'),
          -0.35 , -0.7254250000000002 , -1.25, "scene_2", "to_scene_3", +'', 0 , 0 , 0)
    }else if(sceneNum === 3){
      this.createRunnerInterest(getContent(language, 'click_img_run'),0.35,0.6254249999999992,-1.25, "modal_s3_w1_img", 0)
      // 向右（回退）
      this.createSceneCircle(getContent(language, 'move_img_common'),
          0.35 , -0.7754250000000003 , -1.25, "scene_3", "to_scene_2", +'', 0 , 0 , -3.270329251994328)
      // 向左（前进）
      this.createSceneCircle(getContent(language, 'move_img_common'),
          -0.35 , -0.7754250000000003 , -1.25, "scene_3", "to_scene_4", +'', 0 , 0 , 0)
      // 向下
      this.createSceneCircle(getContent(language, 'move_img_common'),
          0 , -0.8754250000000003 , -1.25, "scene_3", "to_scene_14", +'', 0 , 0 , 1.6165926535897934)
      // this.camera.position.set(-0.0018712523882727585,0.0012942570640334572,-0.009737726282432756)
      // this.createSceneCircle(getContent(language, 'move_img_common'),
      //     0,-0.42542500000000005,0.7000000000000007, "scene_32", "to_scene_4", +'3_to_4', -2.967059728390359,-0.1745329251994329,1.6165926535897934)
    }else if(sceneNum === 4){
      this.createRunnerInterest(getContent(language, 'click_img_run'),0.35,0.5725,-1.25, "modal_s4_w1_img", 0)
      // 向右（回退）
      this.createSceneCircle(getContent(language, 'move_img_common'),
          0.35 , -0.7254250000000002 , -1.25, "scene_4", "to_scene_3", +'', 0 , 0 , -3.270329251994328)
      // 向左（前进）
      this.createSceneCircle(getContent(language, 'move_img_common'),
          -0.35 , -0.7254250000000002 , -1.25, "scene_4", "to_scene_5", +'', 0 , 0 , 0)
      // 向下
      this.createSceneCircle(getContent(language, 'move_img_common'),
          0 , -0.8754250000000003 , -1.25, "scene_4", "to_scene_13", +'', 0 , 0 , 1.6165926535897934)
    }else if(sceneNum === 5){
      this.createRunnerInterest(getContent(language, 'click_img_run'),0.35,0.5754249999999992,-1.2, "modal_s5_w1_img", 0)
      // 向右（回退）
      this.createSceneCircle(getContent(language, 'move_img_common'),
          0.35 , -0.7254250000000002 , -1.25, "scene_5", "to_scene_4", +'', 0 , 0 , -3.270329251994328)
      // 向左（前进）
      this.createSceneCircle(getContent(language, 'move_img_common'),
          -0.35 , -0.7254250000000002 , -1.25, "scene_5", "to_scene_6", +'', 0 , 0 , 0)
    }else if(sceneNum === 6){
      this.createRunnerInterest(getContent(language, 'click_img_run'),0.35,0.625017457499999999998,-1.25, "modal_s6_w1_img", 0)
      // 向右（回退）
      this.createSceneCircle(getContent(language, 'move_img_common'),
          0.35 , -0.7254250000000002 , -1.25, "scene_6", "to_scene_5", +'', 0 , 0 , -3.270329251994328)
      // 向左（前进）
      this.createSceneCircle(getContent(language, 'move_img_common'),
          -0.35 , -0.7254250000000002 , -1.25, "scene_6", "to_scene_7", +'', 0 , 0 , 0)
    }else if(sceneNum === 7){
      this.createRunnerInterest(getContent(language, 'click_img_run'),0.35,0.7257457499999999998,-1.25, "modal_s7_w1_img", 0)
      // 向右（回退）
      this.createSceneCircle(getContent(language, 'move_img_common'),
          0.35 , -0.6254250000000002 , -1.25, "scene_7", "to_scene_6", +'', 0 , 0 , -3.270329251994328)
      // 向左（前进）
      this.createSceneCircle(getContent(language, 'move_img_common'),
          -0.35 , -0.6254250000000002 , -1.25, "scene_7", "to_scene_8", +'', 0 , 0 , 0)
    }else if(sceneNum === 8){
      this.camera.position.set(0.0005563844606823664,0.027230064629541428,0.09621961347148887)
      this.createRunnerInterest(getContent(language, 'click_img_run'),0.37,-0.17542500000000005,-1.25, "modal_s8_w1_imglist", 0)
      // 向右（回退）
      this.createSceneCircle(getContent(language, 'move_img_common'),
          0.37 , -1.0254250000000002 , -1.25, "scene_8", "to_scene_7", +'', 0 , 0 , -3.270329251994328)
      // 向左（前进）
      this.createSceneCircle(getContent(language, 'move_img_common'),
          -0.28 , -1.0254250000000002 , -1.25, "scene_8", "to_scene_9", +'', 0 , 0 , 0)
    }else if(sceneNum === 9){
      this.createRunnerInterest(getContent(language, 'click_img_run'),0.35,0.4745749999999999,-1.25, "modal_s9_w1_img", 0)
      // 向右（回退）
      this.createSceneCircle(getContent(language, 'move_img_common'),
          0.35 , -0.7254250000000002 , -1.25, "scene_9", "to_scene_8", +'', 0 , 0 , -3.270329251994328)
      // 向左（前进）
      this.createSceneCircle(getContent(language, 'move_img_common'),
          -0.35 , -0.7254250000000002 , -1.25, "scene_9", "to_scene_10", +'', 0 , 0 , 0)
    }else if(sceneNum === 10){
      this.createRunnerInterest(getContent(language, 'click_img_run'),0.35,0.40574999999999972,-1.25, "modal_s10_w1_img", 0)
      // 向右（回退）
      this.createSceneCircle(getContent(language, 'move_img_common'),
          0.35 , -0.7254250000000002 , -1.25, "scene_10", "to_scene_9", +'', 0 , 0 , -3.270329251994328)
      // 向左（前进）
      this.createSceneCircle(getContent(language, 'move_img_common'),
          -0.35 , -0.7254250000000002 , -1.25, "scene_10", "to_scene_11", +'', 0 , 0 , 0)
      // 向下
      this.createSceneCircle(getContent(language, 'move_img_common'),
          0 , -0.9454250000000003 , -1.25, "scene_10", "to_scene_13", +'', 0 , 0 , 1.6165926535897934)
    }else if(sceneNum === 11){
      this.createRunnerInterest(getContent(language, 'click_img_run'),0.35,0.38245749999999999,-1.25, "modal_s11_w1_imglist", 0)
      // 向右（回退）
      this.createSceneCircle(getContent(language, 'move_img_common'),
          0.35 , -0.7254250000000002 , -1.25, "scene_11", "to_scene_10", +'', 0 , 0 , -3.270329251994328)
      // 向左（前进）
      this.createSceneCircle(getContent(language, 'move_img_common'),
          -0.35 , -0.7254250000000002 , -1.25, "scene_1", "to_scene_12", +'', 0 , 0 , 0)
      // 向下
      this.createSceneCircle(getContent(language, 'move_img_common'),
          0 , -0.9254250000000003 , -1.25, "scene_11", "to_scene_14", +'', 0 , 0 , 1.6165926535897934)
    }else if(sceneNum === 12){
      this.createRunnerInterest(getContent(language, 'click_img_run'),0.35,0.2825,-1.25, "modal_s12_w1_img", 0)
      // 向右（回退）
      this.createSceneCircle(getContent(language, 'move_img_common'),
          0.35 , -0.7254250000000002 , -1.25, "scene_12", "to_scene_11", +'', 0 , 0 , -3.270329251994328)
      // 向左（前进）
      this.createSceneCircle(getContent(language, 'move_img_common'),
          -0.35 , -0.7254250000000002 , -1.25, "scene_12", "to_scene_1", +'', 0 , 0 , 0)
    }else if(sceneNum === 13){
      this.createRunnerInterest(getContent(language, 'click_img_run'),0.37499999999999994,0.32457499999999995,-1.25, "modal_s13_w1_img", 0)
      // 向右
      this.createSceneCircle(getContent(language, 'move_img_common'),
          0.35 , -0.7254250000000002 , -1.25, "scene_13", "to_scene_4", +'', 0 , 0 , -3.270329251994328)
      // 向左
      this.createSceneCircle(getContent(language, 'move_img_common'),
          -0.35 , -0.7254250000000002 , -1.25, "scene_13", "to_scene_10", +'', 0 , 0 , 0)
      // 向上
      this.createSceneCircle(getContent(language, 'move_img_common'),
          0 , -0.9 , -1.25, "scene_13", "to_scene_14", +'', 0 , 0 , 1.6165926535897934)
    }else if(sceneNum === 14){
      this.camera.position.set(0.0005563844606823664,0.027230064629541428,0.09621961347148887)
      this.createStaticInterest(getContent(language, 'click_img_video'),-0.1249999999999999,-0.3825425,-1.25, "modal_s14_w1_video", 0)
      this.createStaticInterest(getContent(language, 'click_img_video'),0.57529750000000000007,0.225457499999999998,-1.5, "modal_s14_w2_video", 0)
      // 向右（回退）
      this.createSceneCircle(getContent(language, 'move_img_common'),
          0.35 , -0.7254250000000002 , -1.25, "scene_14", "to_scene_11", +'', 0 , 0 , -3.270329251994328)
      // 向左（前进）
      this.createSceneCircle(getContent(language, 'move_img_common'),
          -0.35 , -0.7254250000000002 , -1.25, "scene_14", "to_scene_3", +'', 0 , 0 , 0)
      // 向下
      this.createSceneCircle(getContent(language, 'move_img_common'),
          0 , -0.92754250000000003 , -1.25, "scene_14", "to_scene_13", +'', 0 , 0 , 1.6165926535897934)
    }
      //添加兴趣点事件
    this.add_interst_action()
      // 添加跳转事件
    this.add_toPoint_click_handle()
  }

  // 释放three.js资源
  beforeDestroy() {
    try {
      this.scene.clear();
      this.renderer.dispose();
      // this.renderer.forceContextLoss();
      this.renderer.content = null;
      // // cancelAnimationFrame(animationID) // 去除animationFrame
      let gl = this.renderer.domElement.getContext("webgl");
      gl && gl.getExtension("WEBGL_lose_context").loseContext();
    }catch (e) {
      console.log("beforeDestroy",e)
    }
    console.log("beforeDestroy end")
  }

    // mouseLight product21-trans logo-trans up-down-light num-light
    // swiper orbitalVideo secondVideo inceptionVideo meadowfoamVideo meetVideo behindVideo historyVideo
    //兴趣点动作
  add_interst_action(place){
    this.hoverHandlers.push(select => {
      var action = false
      this.interstPoints.forEach(interstPoint => {
        if (select.name === interstPoint.name) {
          this.annieAction = select.name
          action = true
        }
      })
      this.toPoints.forEach(toPoint => {
        if (select.name === toPoint.name) {
          this.annieAction = select.name
          action = true
        }
      })
      if(!action){
        this.annieAction = ""
      }
    })
  }

  //动态图标 大小
  createRunnerInterest(runImg, x, y, z, name, rotationY){
    var runnerTexture = new THREE.ImageUtils.loadTexture(runImg);
    var annie = new TextureAnimator( runnerTexture, 58, 1, 58, 20, name ); // texture, #horiz, #vert, #total, duration.
    var runnerMaterial = new THREE.MeshBasicMaterial({
      map: runnerTexture,
      side:THREE.DoubleSide,
      transparent: true, // 透明
    } );
    var runnerGeometry = new THREE.PlaneGeometry(0.175, 0.175, 1, 1);
    var runner = new THREE.Mesh(runnerGeometry, runnerMaterial);
    runner.name = name
    // runner.position.set(-100,25,0);

    runner.position.set(x, y, z)
    if(rotationY){
      runner.rotation.y = rotationY
    }
    this.annies.push(annie)

    this.interstPoints.push(runner)
    this.pickHandlers.push(selects => {
      const select = selects[0].object
      if (select.name === name) {
        this.openModal(name)
      }
    })
    this.scene.add(runner);
  }

  //静态图标 大小
  createStaticInterest(img, x, y, z, name, rotationY){
    var texture = new THREE.ImageUtils.loadTexture(img);
    var runnerMaterial = new THREE.MeshBasicMaterial({
      map: texture,
      side:THREE.DoubleSide,
      transparent: true, // 透明
    } );
    var runnerGeometry = new THREE.PlaneGeometry(0.125, 0.125, 1, 1);
    var runner = new THREE.Mesh(runnerGeometry, runnerMaterial);
    runner.name = name
    // runner.position.set(-100,25,0);

    runner.position.set(x, y, z)
    if(rotationY){
      runner.rotation.y = rotationY
    }

    this.interstPoints.push(runner)
    this.pickHandlers.push(selects => {
      const select = selects[0].object
      if (select.name === name) {
        this.openModal(name)
      }
    })
    this.scene.add(runner);
  }


  createSceneCircle(img, x, y, z, from, toName, color, rotationX, rotationY, rotationZ){
    var texture = new THREE.TextureLoader().load(img);

    var geometry = new THREE.CircleGeometry(0.0525, 12);

    // var material = new THREE.MeshBasicMaterial( {color: 0xffff00, side: THREE.DoubleSide} );
    const material = new THREE.MeshBasicMaterial({
      map: texture,
      opacity: 1, // 透明度
      transparent: true, // 透明
    })
    var mesh = new THREE.Mesh( geometry, material );
    mesh.position.set(x, y, z)
    if(rotationX){
      mesh.rotation.x = rotationX
    }
    if(rotationY){
      mesh.rotation.y = rotationY
    }
    if(rotationZ){
      mesh.rotation.z = rotationZ
    }
    mesh.name = from+toName
    mesh.toName = toName
    this.toPoints.push(mesh)
    this.scene.add( mesh );
  }

  add_toPoint_click_handle = () => {
    this.pickHandlers.push(selects => {
      const select = selects[0].object
      this.ableMovingCameraLook(select.position.x, select.position.y, select.position.z)
      for(let i=0;i<=17;i++){
        if(select.toName === 'to_scene_'+i){
          const _this = this
          this.moving(function(){
            _this.create_scene(i)
          })
          break
        }
      }
    })
    //测试键盘事件
    // this.setKeyEventsTest();//定义键盘按键事件
  }

  componentDidMount () {
    this.init(() => {
      this.initScene();
      this.initControls();
      this.init_scene_0();
    })
    window.reactApp = this
  }

  setKeyEventsTest = (name) => {
    if(!name){
      name = ""
    }
    var _this = this
    const clock = new THREE.Clock()
    const animate = () => {
      requestAnimationFrame(animate);

      const delta = clock.getDelta()
      this.controls.update(delta);

      this.renderer.render(this.scene, this.camera);
    }
    window.removeEventListener("keydown", this.testListener, true)
    this.testListener = function(e){
      var o = null;
      _this.toPoints.forEach((item)=>{
        //jumphere
        if(item.name == name){
          o = item;
        }
      })
      _this.interstPoints.forEach((item)=>{
        //jumphere
        if(item.name == name){
          o = item;
        }
      })
      if(e.key === 'ArrowUp'){
        o.position.y += 0.05
      }else if(e.key === 'ArrowDown'){
        o.position.y -= 0.05
      }else if(e.key === 'ArrowLeft'){
        o.position.x -= 0.05
      }else if(e.key === 'ArrowRight'){
        o.position.x += 0.05
      }else if(e.key === '4'){
        o.position.z += 0.05
      }else if(e.key === '6'){
        o.position.z -= 0.05
      }else if(e.key === 'n'){
        o.rotation.y -= Math.PI/18
      }else if(e.key === 'm'){
        o.rotation.y += Math.PI/18
      }else if(e.key === 'v'){
        o.rotation.x -= Math.PI/18
      }else if(e.key === 'b'){
        o.rotation.x += Math.PI/18
      }else if(e.key === 'x'){
        o.rotation.z -= Math.PI/18
      }else if(e.key === 'c'){
        o.rotation.z += Math.PI/18
      }else if(e.key === 'Enter'){
        if(o){
          console.log(o.name+":"+o.position.x+","+o.position.y+","+o.position.z+"|"+
          o.rotation.x+","+o.rotation.y+","+o.rotation.z)
        }
      }else if(e.key === 'z'){
        alert(_this.camera.position.x+","+_this.camera.position.y+","+_this.camera.position.z)
      }
      // if(o && (o.name||o.x)){
      //   console.log(o.name, o.position.x,",",o.position.y,",",o.position.z,",",
      //   o.rotation.x,",",o.rotation.y,",",o.rotation.z)
      // }
      animate()
    }
    window.addEventListener('keydown',this.testListener, true);
  }

  handleModalCnacel = () => {
    this.setState({ modalVisible: false })
  }

  // 输入+点击事件
  nameClick = () => {
    console.log("nameClick", this.refs.name.value)
    this.setKeyEventsTest(this.refs.name.value)
    this.action(this.refs.name.value)
  }

  action = (name) => {
    this.annieAction = name
  }

  ableMovingCameraLook(x, y, z){
    this.movingCameraAble = true;
    this.movingCameraX = x;
    this.movingCameraY = y;
    this.movingCameraZ = z;
  }

  ableDestCameraLook(x, y, z){
    this.destCameraAble = true;
    this.destCameraX = x;
    this.destCameraY = y;
    this.destCameraZ = z;
  }

  componentDidUpdate (prevProps, prevState) {
    const { progress, showEnter } = this.state
    const { progress: prevProgress, showEnter: prevShowEnter} = prevState

    if (progress === 100 && progress !== prevProgress) {
      console.log("加载完成")
      // this.setState({ showEnter: true })
    }
    if (!showEnter && prevShowEnter) {
      this.props.changeHeaderColor('blue')
    }
  }

  handleEnter = () => {
    this.setState({
      showEnter: false
    })
  }

  render () {
    const { progress, modalVisible, modalType, showEnter, videoBackground } = this.state
    const { toggleAudioPlay, language } = this.props

    // 修改html.title
    if(language === 'en'){
      document.title = 'GALLERY'
    }else if(language === 'ch'){
      document.title = '寰宇艺境'
    }

    return (
      <div>
        {/*  <span id='test' style={{marginTop: '60px', display: 'block', position: 'absolute'}}>*/}
        {/*  <input id='nameInput' ref="name"></input>*/}
        {/*  <button id='nameButton' onClick={this.nameClick.bind(this)}>LOCATE</button>*/}
        {/*</span>*/}
        <canvas ref={this.canvasRef} style={{ display: 'block', width: '100vw',height: 'calc(100vh-50px)',
          minWidth: '100vw',minHeight:'calc(100vh-50px)'  }}></canvas>

        <>
          {/* <Smoke progress={progress} language={language}></Smoke> */}
           {showEnter && <Enter onEnter={this.handleEnter} language={language} progress={progress}></Enter>}
          <DetailModal modalVisible={modalVisible} modalType={modalType}
          onCancel={this.handleModalCnacel} toggleAudioPlay={toggleAudioPlay}
          changeVedioBackground={this.changeVedioBackground}
          language={language}></DetailModal>
        </>
      </div>
    )
  }
}
